/* This is a generated file, do not edit it directly */
import * as Types from '@noah-labs/shared-schema-gql';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions } from 'react-query';
import { useAppSyncRequest } from '@noah-labs/fe-shared-data-access-shared';
export type SubscriptionJwtQueryVariables = Types.Exact<{ [key: string]: never }>;

export type SubscriptionJwtQuery = {
  __typename?: 'Query';
  subscriptionJwt: { __typename?: 'JwtToken'; Token: string };
};

export type OnAccountUpdateSubscriptionVariables = Types.Exact<{ [key: string]: never }>;

export type OnAccountUpdateSubscription = {
  __typename?: 'Subscription';
  onAccountUpdate?: {
    __typename?: 'SubAccountResponse';
    UserID: string;
    Data: {
      __typename?: 'AccountResponse';
      ID: string;
      AccountType: Types.AccountType;
      CurrencyCode: Types.CurrencyCode;
      Version: number;
      VersionBalance: number;
      Balance?: {
        __typename: 'AccountBalanceCurrent';
        Total: string;
        Lifetime: string;
        ID: string;
        Available: string;
        AccountType: Types.AccountType;
      } | null;
    };
  } | null;
};

export const SubscriptionJwtDocument = /*#__PURE__*/ `
    query subscriptionJwt {
  subscriptionJwt {
    Token
  }
}
    `;

export const useSubscriptionJwtQuery = <TData = SubscriptionJwtQuery, TError = unknown>(
  variables?: SubscriptionJwtQueryVariables,
  options?: UseQueryOptions<SubscriptionJwtQuery, TError, TData>,
) => {
  return useQuery<SubscriptionJwtQuery, TError, TData>(
    variables === undefined ? ['subscriptionJwt'] : ['subscriptionJwt', variables],
    useAppSyncRequest<SubscriptionJwtQuery, SubscriptionJwtQueryVariables>(
      SubscriptionJwtDocument,
    ).bind(null, variables),
    options,
  );
};

useSubscriptionJwtQuery.getKey = (variables?: SubscriptionJwtQueryVariables) =>
  variables === undefined ? ['subscriptionJwt'] : ['subscriptionJwt', variables];

export const useInfiniteSubscriptionJwtQuery = <TData = SubscriptionJwtQuery, TError = unknown>(
  variables?: SubscriptionJwtQueryVariables,
  options?: UseInfiniteQueryOptions<SubscriptionJwtQuery, TError, TData>,
) => {
  const query = useAppSyncRequest<SubscriptionJwtQuery, SubscriptionJwtQueryVariables>(
    SubscriptionJwtDocument,
  );
  return useInfiniteQuery<SubscriptionJwtQuery, TError, TData>(
    variables === undefined
      ? ['subscriptionJwt.infinite']
      : ['subscriptionJwt.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options,
  );
};

useInfiniteSubscriptionJwtQuery.getKey = (variables?: SubscriptionJwtQueryVariables) =>
  variables === undefined ? ['subscriptionJwt.infinite'] : ['subscriptionJwt.infinite', variables];

export const OnAccountUpdateDocument = /*#__PURE__*/ `
    subscription onAccountUpdate {
  onAccountUpdate {
    UserID
    Data {
      ID
      AccountType
      CurrencyCode
      Balance {
        __typename
        ... on AccountBalanceCurrent {
          Total
          Lifetime
          ID
          Available
          AccountType
        }
      }
      Version
      VersionBalance
    }
  }
}
    `;
